export const isBatchRoute = (pathname: string) => pathname.startsWith('/batch-returns');

export const isBatchReturnHome = (pathname: string) => pathname === '/batch-returns';

export const isReturnHome = (pathname: string) => pathname === '/';

export const isHomeRoute = (pathname: string) => isReturnHome(pathname) || isBatchReturnHome(pathname);
